export const environment = {
  production: true,
  providers: [],
  baseApiUrl: `https://core.arconcontainer.com`,
  socketApiUrl: `wss://core.arconcontainer.com`,
  redirectOnServerError: true,
  arthakoshFrontendBaseUrl: 'https://arthkosh.arconcontainer.com',
  showArthakoshLink: false
};
